import { useEffect, useState } from 'react';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';

// Endpoint URL
//export const endpoint = 'https://login.microsoftonline.com/eb763ce9-052a-4e6c-aa3f-dce37cba904f/oauth2/v2.0/token';//'https://<tenant name>.sharepoint.com/'; 'https://login.microsoftonline.com/eb763ce9-052a-4e6c-aa3f-dce37cba904f';
export const endpoint = 'https://login.microsoftonline.com/eb763ce9-052a-4e6c-aa3f-dce37cba904f/oauth2/v2.0/authorize';

// App Registration ID
const appId = 'b65c7c1a-bdec-4276-b541-e99099f3a147';

// this is the custom api scope exposed in Azure for this app, required by msal when acquiring token
const scope = `api://${appId}/api`

export const msalConfig = {
    auth: {
        clientId: appId,
        authority: 'https://login.microsoftonline.com/eb763ce9-052a-4e6c-aa3f-dce37cba904f',
        redirectUri: window.location.origin + "/spa",
        postLogoutRedirectUri: window.location.origin + "/spa",
    },
    cache: {
        cacheLocation: 'localStorage',
    }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const getToken = async () => {
    const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    const accounts = msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
        return
    }
    const request = {
        scopes: [scope],
        account: activeAccount || accounts[0]
    };

    const authResult = await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken
};

export const useMSALToken = () => {
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(instance.getActiveAccount() || accounts[0] || null);

    useEffect(() => {
        const fetchToken = async () => {
            if (!instance || !account) {
                console.warn('No active account exists.');
                setLoading(false);  // Prevent getting stuck if no account exists
                return;
            }

            try {
                const response = await instance.acquireTokenSilent({
                    scopes: [scope],
                    account: account,
                });
                console.log('Silent token acquisition completed.');
                setAccessToken(response.accessToken);
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    console.warn('Silent token acquisition failed, attempting popup login.');
                    try {
                        const response = await instance.acquireTokenPopup({
                            scopes: [scope],
                            account: account,
                        });
                        setAccessToken(response.accessToken);
                    } catch (popupError) {
                        console.error('Popup login failed:', popupError);
                    }
                } else {
                    console.error('Token acquisition failed:', error);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchToken();
    }, [account, instance]);  // Make sure this does not re-run unnecessarily

    return { accessToken, loading };
};